import axios from 'axios';

const claimTicket = id => {
  return axios.put(`/live-chat/tickets/${id}`);
};

const getSuggestion = (subscriberId) => {
  return axios.get(`/live-chat/suggestions/${subscriberId}`);
};

export { claimTicket, getSuggestion };
